import * as React from "react";
import { useState, useRef } from "react";

import Box from "@mui/material/Box";
// import Button from '@mui/material/Button';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Formik, Field, Form, ErrorMessage } from "formik";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import {
  Button,
  Checkbox,
  FormGroup,
  TextField,
  Divider,
  FormHelperText,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import PropTypes from "prop-types";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
// import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from "@mui/material/Radio";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkErrorMessage,
  checkResponseData
} from "../../../../utils/utilsFunctions";
import { createTicketValidation } from "../../../../../../validations/supportsFormsValidation";
import { createTicketApi } from "../../../../../../services/supportApi";

export default function CreateTicket(props) {
  const { selectVideoBox, handleCloseSelectVideoBox } = props;
  //   const fileRef = useRef(null);
  const [subject, setSubject] = useState("");
  const [ticketContent, setTicketContent] = useState("");
  const [title, setTitle] = useState("");
  const [file, setFile] = useState("");

  const initialValues = {
    subject: "",
    ticketContent: "",
    title: "",
    file: "",
  };

  const createTicketToBack = async (data, props) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await createTicketApi(data)
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setSubject("");
        setTicketContent("");
        setTitle("");
        // fileRef.current.value = null;
        props.setFieldValue("subject", "");
        props.setFieldValue("ticketContent", "");
        props.setFieldValue("title", "");
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      console.error("Error-reportBugToBack", error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  const onSubmit = (values, props) => {
    let newValues = {
      subject: values.subject,
      ticketContent: values.ticketContent,
      title: values.title,
      file: values.file,
    };
    createTicketToBack(newValues, props);
    // console.log("onSubmitnewValues", newValues);
  };

  return (
    <Box
      sx={{
        m: 1,
        borderRadius: " 15px",
        p: 1,
        border: 2,
        borderColor: "secondary.main",
        backgroundColor: "#e5b7b74a",
      }}
    >
      {/* <Divider textAlign="left" sx={{mb:2}}>گزارش وجود مشکل</Divider> */}
      <Formik
        initialValues={initialValues}
        validationSchema={createTicketValidation}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <Field
              focused
              as={TextField}
              sx={{ pr: 5, my: 2 }}
              value={title}
              type="text"
              name="title"
              label="عنوان"
              rows={4}
              placeholder="عنوان"
              onChange={(e) => {
                props.setFieldValue("title", e.target.value);
                setTitle(e.target.value);
              }}
            />
            <FormHelperText
              sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
            >
              <ErrorMessage name="title" />
            </FormHelperText>
            <br />
            <FormControl style={{ minWidth: 170 }}>
              <InputLabel id="demo-simple-select-label">بخش مربوطه</InputLabel>
              <Select
                size="small"
                label="subject"
                name="subject"
                id="subject"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                  props.setFieldValue("subject", e.target.value);
                }}
              >
                <MenuItem key={0} value={"support"}>
                  پشتبانی
                </MenuItem>
                <MenuItem autoFocus key={1} value="technical">
                  واحد فنی
                </MenuItem>
                <MenuItem key={2} value={"financial"}>
                  واحد مالی
                </MenuItem>
                <MenuItem autoFocus key={3} value="other">
                  دیگر واحد ها
                </MenuItem>
                {/* {Object.keys(languagesList).map((option, index) => (
                  <MenuItem key={index + 2} value={option}>
                    {languagesList[option]}
                  </MenuItem>
                ))} */}
              </Select>
              <FormHelperText sx={{ color: "#f96767", textAlign: "center" }}>
                <ErrorMessage name="subject" />
              </FormHelperText>
            </FormControl>
            <Typography>متن پیام:</Typography>
            <Field
              variant="filled"
              focused
              as={TextField}
              sx={{ pr: 5, my: 1 }}
              value={ticketContent}
              type="text"
              multiline
              name="ticketContent"
              label="متن پیام"
              rows={4}
              fullWidth
              placeholder=""
              onChange={(e) => {
                props.setFieldValue("ticketContent", e.target.value);
                setTicketContent(e.target.value);
              }}
            />
            <FormHelperText
              sx={{ m: 0, p: 0, color: "#f96767", textAlign: "center" }}
            >
              <ErrorMessage name="ticketContent" />
            </FormHelperText>
            {/* <Button variant="contained" component="label">
              انتخاب عکس پیوست (حداکثر 2 مگابایت)
              <input
                hidden
                id="file"
                name="file"
                type="file"
                ref={fileRef}
                onChange={(e) => {
                  props.setFieldValue("file", e.target.files[0]);
                  setFileSelected(e.target.files[0]);
                }}
              />
              <AttachFileIcon sx={{ mx: 1 }} />
            </Button>
            {fileSelected ? (
              <Button
                variant="contained"
                sx={{ mx: 2 }}
                color="error"
                component="label"
                onClick={(e) => {
                  fileRef.current.value = null;
                  props.setFieldValue("file", "");
                  setFileSelected(false);
                }}
              >
                حذف فایل
              </Button>
            ) : (
              ""
            )} */}

            <FormHelperText sx={{ color: "#f96767", textAlign: "center" }}>
              <ErrorMessage name="file" />
            </FormHelperText>
            <br />
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 1 }}
              color="success"
            >
              ارسال
            </Button>
          </Form>
        )}
      </Formik>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </Box>
  );
}
